/** The one label a customer of the hosted service sees for whatever answers. */
export const HOSTED_MODEL_LABEL = "Preá";

/** Model, provider and gateway names that must never reach a customer. */
const MODEL_NAME_PATTERN = new RegExp(
  `\\b(?:${[
    "orbin[-_ ]?(?:main|embeddings|inference)",
    "inference\\.orbin\\.tech",
    "openrouter",
    "anthropic",
    "openai",
    "google[-_ ]?(?:vertex|gemini)",
    "amazon[-_ ]?bedrock",
    "cloudflare[-_ ]?ai",
    "deepseek",
    "mistral(?:ai)?",
    "moonshot",
    "gpt-?[0-9][\\w.-]*",
    "o[134](?:-mini|-pro)?",
    "claude[\\w.-]*",
    "gemini[\\w.-]*",
    "llama[\\w.-]*",
    "qwen[\\w.-]*",
    "grok[\\w.-]*",
    "kimi[\\w.-]*",
    "glm-?[0-9][\\w.-]*",
  ].join("|")})\\b`,
  "giu",
);

/** Replaces model and provider names in a sentence the product wrote about a failure. */
export function scrubModelNames(text: string): string {
  return text.replace(MODEL_NAME_PATTERN, HOSTED_MODEL_LABEL);
}
